<template>
<v-menu
  :close-on-content-click="false"
  :nudge-width="100"
  v-model="menu"
  :allow-overflow="true"
  absolute
  max-height="500"
>
  <template v-slot:activator="{ on, attrs }">
    <!-- <span class="text-h3 d-flex mr-2" v-bind="attrs" v-on="on"><v-icon class="mr-3">$vuetify.icons.bars</v-icon>{{ headlineText }}</span> -->
    <v-btn outlined large v-bind="attrs" v-on="on">
      {{ headlineText }}
      <v-icon right>$vuetify.icons.dropdown</v-icon>
    </v-btn>
  </template>

  <v-list dense>
    <v-list-item-group multiple>
      <template v-for="location in rootLocations">

        <v-list-item v-if="location.children.length == 0" :key="location.id" inactive active-class="" color="">
          <template>
            <v-list-item-action>
              <v-checkbox dense :input-value="location.active" @change="click(location)"></v-checkbox>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ location.name }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-list-item>

        <v-list-group :value="false" v-else :key="location.id" active-class="" color="">
            <template v-slot:activator>
              <v-list-item-action>
                <v-checkbox dense :input-value="location.active" @change="click(location)"></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{ location.name }}</v-list-item-title>
              </v-list-item-content>
            </template>

          <v-list-item v-for="child in children(location)" :key="child.locationId" class="ml-4" inactive>
            <template>
              <v-list-item-action>
                <v-checkbox dense :input-value="child.active" @change="click(child)"></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{ child.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-group>

      </template>
    </v-list-item-group>
  </v-list>
</v-menu>
</template>

<script>
export default {
  name: "LocationsMenu",

  props: ["locations"],

  data() {
    return {
      menu: false
    }
  },

  computed: {
    headlineText() {
      if (this.numberActive == 0) {
        return "Keine Region ausgewählt";
      }

      if (this.numberActive == this.locations.length) {
        return "Alle Regionen ausgewählt";
      }

      return this.numberActive + " " + (this.numberActive == 1 ? "Region" : "Regionen") + " ausgewählt";
    },

    numberActive() {
      let number = 0;
      this.locations.forEach(location => {
        if (location.active) {
          number++;
        }
      });
      return number;
    },

    rootLocations() {
      const arr = [];

      this.locations.forEach(location => {
        if (location.parentId == null) {
          arr.push(location);
        }
      });

      return arr;
    }
  },

  methods: {
    children(location) {
      const list = [];

      location.children.forEach(childId => {
        const child = this.locations.find(l => l.locationId == childId);
        list.push(child);
      });

      return list;
    },

    click(location) {
      this.$emit("click", location);
    }
  }
};
</script>
